import { useState } from 'react';
import { VStack, Box, Text } from '@chakra-ui/react';

import type { HexString } from '@/lib/config/wagmi';

import { HistorySection } from './HistorySection';
import { LedgerHistorySection } from './LedgerHistorySection';
import { OpenOrderSection } from './OpenOrderSection';
import { PortfolioTabs } from './PortfolioTabs';
import { PositionSection } from './PositionSection';

interface PortfolioContentProps {
  userAddress: HexString;
  hideTitle?: boolean;
  onViewAllPositions?: () => void;
  onViewAllHistory?: () => void;
  onViewAllOrders?: () => void;
  onViewAllLedgerHistory?: () => void;
}

export function PortfolioContent({
  userAddress,
  hideTitle,
  onViewAllPositions,
  onViewAllHistory,
  onViewAllOrders,
  onViewAllLedgerHistory,
}: PortfolioContentProps) {
  const [activeTab, setActiveTab] = useState('positions');

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'positions': {
        return (
          <PositionSection
            userAddress={userAddress}
            onViewAll={onViewAllPositions}
            hideHeader={true}
          />
        );
      }
      case 'history': {
        return (
          <HistorySection
            userAddress={userAddress}
            onViewAll={onViewAllHistory}
            hideHeader={true}
          />
        );
      }
      case 'orders': {
        return (
          <OpenOrderSection
            userAddress={userAddress}
            onViewAll={onViewAllOrders}
            hideHeader={true}
          />
        );
      }
      case 'depositsWithdrawals': {
        return (
          <LedgerHistorySection
            userAddress={userAddress}
            onViewAll={onViewAllLedgerHistory}
            hideHeader={true}
          />
        );
      }
      // case 'depositsWithdrawals': {
      //   return <DepositsWithdrawalsSection userAddress={userAddress} />;
      // }
      default: {
        return (
          <PositionSection
            userAddress={userAddress}
            onViewAll={onViewAllPositions}
            hideHeader={true}
          />
        );
      }
    }
  };

  return (
    <VStack flex={1} py={{ base: 2, md: 6 }} px={2} gap={{ base: 2, md: 6 }} align="stretch" border=" 1px solid rgba(255, 255, 255, 0.15)" rounded="16px">
      {/* Section Title */}
      <Text display={hideTitle ? 'none': 'block'} fontSize="xl" color="text.t1/90" fontWeight="700" px={4}>
        Portfolio
      </Text>

      <PortfolioTabs
        onTabChange={handleTabChange}
        initialTab={activeTab}
        userAddress={userAddress}
      />

      <Box flex={1}>{renderContent()}</Box>
    </VStack>
  );
}
